var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10091_307144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.45572 19.436L2.45121 9.45772L13.3 0.640658L17.8931 9.78629L4.45572 19.436Z",
    fill: "#F3F4F6",
    stroke: "#C2C7D0",
    strokeWidth: 0.820859
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10091_307144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field_icon.bb4b0ca05399a6902b8eee6a0f46ef2b.svg";